import { AxiosInstance } from '@service/axios-instance';
import { TSignInData } from '@models/sign-in-data';

export async function login(data: TSignInData) {
  const response = AxiosInstance.post('/current_user/login', data, {
    withCredentials: true,
  }).then((res) => res).catch((error) => {
    console.log(error);
    throw error; 
  });

  return response;
}

export function getUser() {
  const response = AxiosInstance.get('/current_user/get_info', {
    withCredentials: true,
  }).then((res) => res).catch((error) => {
    console.log("Erro ao buscar informações do usuário:", error);
    throw error; 
  });

  return response;
}

export function logoutUser() {
  const response = AxiosInstance.delete('/current_user/logoff', {
    withCredentials: true,
  }).then((r)=> {console.log("logout")}).catch( (error) => {
    console.log(error);
    throw error; 
  });

  return response;
}

export function forgotPassword(email: string) {
  return AxiosInstance.post('/users/forgot_password', { email }, {
    withCredentials: true,
  }).then((res) => res).catch((error) => {
    console.log(error);
    throw error;
  });
}

export function verifyResetToken(email: string, token: string) {
  return AxiosInstance.post('/users/verify_reset_token', { email, token }, {
    withCredentials: true,
  }).then((res) => res).catch((error) => {
    console.log(error);
    throw error;
  });
}

export function resetPassword(email: string, token: string, new_password: string) {
  return AxiosInstance.post('/users/reset_password', { email, token, new_password }, {
    withCredentials: true,
  }).then((res) => res).catch((error) => {
    console.log(error);
    throw error;
  });
}
